<script setup>
const props = defineProps({
  coin: {
    type: Object,
    default: {},
  },
});
const { formatMoneyWithCurrency, moneyFormater } = useMoneyFormater();

const { addProductToCart, isInCart } = useCart(props.coin);

// Для модалки
const showModal = ref(false);
const modalImage = ref("");

const openImage = (url) => {
  modalImage.value = url;
  showModal.value = true;
};

const closeModal = () => {
  showModal.value = false;
};
</script>

<template>
  <div class="md:!h-[404px] pt-5 md:pt-8 md:!pb-[56px] w-full md:bg-[#F9F9F9]">
    <div class="container flex flex-row md:space-x-8 px-4 xl:px-0" v-if="coin">
      <div class="w-[355px] h-[330px] hidden md:block">
        <AObverseReserve
          v-if="coin.obverse"
          class="w-[355px] pt-6"
          :obverse="coin.obverse"
          :reverse="coin.reverse"
          :onImageClick="openImage"
        ></AObverseReserve>
      </div>

      <div class="w-full h-auto flex flex-col">
        <div
          class="w-full flex mb-6 md:mb-[50px] flex-row items-center justify-between"
        >
          <nuxt-link :to="localePath('/coins')" class="hidden md:block">
            <button
              class="w-50 h-[50px] buttonCss font-firasans px-3 bg-white hover:bg-[#f0f0f0] space-x-1 md:flex flex-row items-center justify-center text-center rounded-[10px] text-lg border border-[#ADADAD]"
            >
              <a-icon-left-arrow></a-icon-left-arrow>
              <span class="pl-2">К каталогу </span>
            </button>
          </nuxt-link>
          <nuxt-link :to="localePath('/coins')" class="md:hidden">
            <div
              class="relative w-8 h-8 rounded-full flex flex-row justify-center items-center"
              style="box-shadow: 0px 0px 4px 0px #00000040"
            >
              <a-icon-arrow
                class="w-4 h-4 rotate-90"
                color="#000000"
              ></a-icon-arrow>
            </div>
          </nuxt-link>

          <a-button-to-cart
            :to="localePath('/cart')"
            class="w-32 !px-0 md:w-50 !h-9 md:!h-[50px] md:hidden lg:flex"
            fontSize="lg"
            rounded="xs"
            height="small"
            type="primary"
          >
            <!-- <div class="relative md:block hidden">
              <a-icon-basket
                class="w-[27px] h-[21px] md:w-[29px] md:h-[29px]"
              ></a-icon-basket>
              <span
                v-if="1"
                class="absolute -right-1 top-0.5 min-h-3 text-[#000000] max-h-3 rounded-full font-sans bg-[#FCC900] px-1 flex items-center justify-center text-[10px]"
                >1</span
              >
            </div> -->
            <div class="flex flex-row items-center space-x-2">
              <a-icon-basket-check class="w-7 h-7"></a-icon-basket-check>
              <span> Корзина</span>
            </div>
          </a-button-to-cart>
        </div>

        <!-- img -->
        <div class="flex md:hidden flex-row justify-center mb-6 space-x-4">
          <img class="w-34 h-34 object-cover" :src="coin.obverse.url" />
          <img class="w-34 h-34 object-cover" :src="coin.reverse.url" />
        </div>

        <transition name="fade">
          <div
            v-if="showModal"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm"
            @click.self="closeModal"
          >
            <div class="relative max-w-[90vw] max-h-[90vh]">
              <button
                @click="closeModal"
                class="absolute -top-4 -right-4 bg-white text-black rounded-full w-8 h-8 flex items-center justify-center shadow hover:bg-gray-200"
                aria-label="Закрыть"
              >
                ✕
              </button>
              <img
                :src="modalImage"
                alt="Фото монеты"
                class="object-contain max-w-full max-h-[90vh] rounded-lg border border-white shadow-xl"
              />
            </div>
          </div>
        </transition>

        <div
          class="mb-2 md:mb-[30px] text-base md:text-xl lg:text-2xl font-firasans font-medium"
        >
          {{ coin.title }}
        </div>
        <div
          class="text-3xl md:text-[30px] mb-6 md:mb-0 font-sans font-semibold"
        >
          {{ formatMoneyWithCurrency(coin.price) }}
        </div>

        <div class="md:mt-auto hidden md:flex flex-row space-x-5">
          <template v-if="!isInCart">
            <a-button-to-cart
              @click="addProductToCart"
              class="w-62"
              fontSize="lg"
              rounded="xs"
              :disabled="coin.count <= 0"
              height="small"
              type="primary"
            >
              <div class="flex flex-row space-x-2">
                <a-icon-plus></a-icon-plus> <span> Добавить в корзину</span>
              </div>
            </a-button-to-cart>
          </template>
          <template v-else>
            <a-button-to-cart
              to="/cart"
              class="w-62"
              fontSize="lg"
              rounded="xs"
              height="small"
              type="secondary"
            >
              <div class="flex flex-row space-x-3">
                <a-icon-check1 class="w-[17px] h-[18px]"></a-icon-check1>
                <span> В корзине</span>
              </div>
            </a-button-to-cart>
            <a-cart-item-editor
              class="hidden lg:block"
              v-if="coin.count > 0"
              :min="1"
              :max="coin.count"
              :product="coin"
            ></a-cart-item-editor>
          </template>
        </div>
        <div class="w-full md:hidden">
          <template v-if="!isInCart">
            <a-button-to-cart
              @click="addProductToCart"
              class="w-full !h-[42px]"
              fontSize="lg"
              rounded="xs"
              outlined
              type="secondary"
            >
              + В корзину
            </a-button-to-cart>
          </template>
          <template v-else>
            <a-button-to-cart
              to="/cart"
              class="w-full !h-[42px]"
              fontSize="lg"
              rounded="xs"
              outlined
              type="secondary"
            >
              <div class="flex flex-row space-x-3">
                <a-icon-check1 class="w-[17px] h-[18px]"></a-icon-check1>
                <span> В корзине</span>
              </div>
            </a-button-to-cart>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
